import {getApi} from "../../services/httpService";

export function serviceList(params){
    return getApi().get('user/registered/service',{
        params: params
    })
}